/**
 * Custom behavior for LockStock.
 * Keep this file focused on store UX only; checkout and payment stay native to Shopify.
 */
(function () {
  var scrollButton = document.getElementById('scrollToTop');

  if (scrollButton && window.matchMedia('(max-width: 768px)').matches) {
    window.addEventListener('scroll', function () {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop;
      scrollButton.style.display = pageOffset > 1200 ? 'block' : 'none';
    }, { passive: true });
  }

  function parseBrazilianMoney(value) {
    if (!value) return 0;
    return Number(String(value).replace(/[^0-9,.-]/g, '').replace('.', '').replace(',', '.')) || 0;
  }

  function formatBrazilianMoney(value) {
    return value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function updateInstallments() {
    var priceElement = document.querySelector('.product-form__info-item .price--highlight');
    var installmentElement = document.querySelector('.parcelamento');

    if (!priceElement || !installmentElement) return;

    var price = parseBrazilianMoney(priceElement.textContent);
    if (!price) return;

    var installments = Math.min(10, Math.floor(price / 14));
    if (installments < 1) installments = 1;
    var installmentPrice = price / installments;

    installmentElement.innerHTML = '<span>em até ' + installments + 'x sem juros de <b>' + formatBrazilianMoney(installmentPrice) + '</b></span>';
  }

  function normalizeColor(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  function loadColorProduct(target) {
    if (
      !target ||
      !target.matches('.product-form__single-selector') ||
      window.location.pathname.indexOf('cores-variadas') === -1
    ) {
      return;
    }

    var selectedColor = normalizeColor(target.value);
    var links = document.querySelectorAll('.tdl-related-swatches__item');

    for (var index = 0; index < links.length; index += 1) {
      if (normalizeColor(links[index].textContent) === selectedColor) {
        window.location.assign(links[index].href);
        return;
      }
    }
  }

  document.addEventListener('variant:changed', function () {
    window.setTimeout(updateInstallments, 150);
  });

  document.addEventListener('change', function (event) {
    loadColorProduct(event.target);

    if (event.target && event.target.matches('.block-swatch__radio')) {
      window.setTimeout(updateInstallments, 150);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateInstallments);
  } else {
    updateInstallments();
  }
})();
